import { Context } from '@nuxt/types/app';
import { scrollToAnchorWhenReady } from '~/utility/helpers';

export default ({ app }: Context) => {
  // scrollBehavior is not called on initial page load in Vue Router 3 history mode.
  // This plugin handles the case where the user opens a page with a hash URL directly
  // (new tab, hard reload, shared link with anchor).
  app.router!.onReady(() => {
    const hash = window.location.hash;
    if (!hash) return;

    scrollToAnchorWhenReady(hash.slice(1));
  });
};
